import { useCallback, useState } from "react";

export const useScreenListeners = <T>() => {
    const [routeName, setRouteName] = useState<T>();
    const screenListeners = useCallback((newState: { route: { name: T } }) => {
        setRouteName(newState.route.name);
    }, []);

    return { routeName, screenListeners };
};
